import { PlayerPBLPage } from '@hendrx/core/pbl/pages/PlayerPBLPage';
import { createFileRoute } from '@tanstack/react-router';

import { useResponsiveRootFontSize } from 'shared/utils/useResponsiveRootFontSize';

export const Route = createFileRoute('/player/pbl/$pblDraftId')({
  component: PlayerPBLPageComponent
});

function PlayerPBLPageComponent() {
  useResponsiveRootFontSize({ minFontSize: 8 });

  const { pblDraftId } = Route.useParams();

  return <PlayerPBLPage pblDraftId={pblDraftId} />;
}
